import styled from "@emotion/styled"
import Image from "components/media/ImageCLD"
import Video, { cssContainer, cssFallback, cssPoster, cssVideo } from "components/media/VideoCLD"
import { cssVars } from "components/nav-v2/Wrapper"
// import ScrollInvit from "components/scroll-invit/ScrollInvit"
import { fullGrid } from "css/grid"
import { useEffect, useMemo, useRef, useState, useCallback } from "react"
import TextBlock from "./TextBlock"

const Root = styled.div`
  ${fullGrid}
  /* height: 200vh;
  margin-top: calc((var(${cssVars.main.safe}) - 1px) * -1); */
  position: relative;
  height: calc(100svh - var(${cssVars.main.safe}) + 1px);
`

const MediaContainer = styled.div`
  grid-column: doc;
  grid-row: 1;
  /* height: calc(100vh + 2px); */
  height: 100%;
  overflow: hidden;
  /* position: sticky; */
  /* top: 0; */
  width: 100%;

  .${cssContainer} {
    height: 100%;
    width: 100%;
  }

  picture,
  img,
  .${cssVideo}, .${cssPoster}, .${cssFallback} {
    display: block;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`

let _timeout
export default function HeroMedia({ theme, heading, cta, media, use_os_logo, animated_logo }) {
  const rvideo = useRef()
  const raction = useRef()
  const [ready, setReady] = useState(false)

  const themeClass = theme?.theme ?? "dark-theme"

  const onMediaClick = useCallback(e => {
    if (e.target.closest("a, button")) return
    raction.current?.click()
  }, [])

  const { video, image } = useMemo(() => {
    const video = media?.find(m => m?.video_cld)?.video_cld ?? null
    const image = video ? null : media?.find(m => m?.image_cld)?.image_cld ?? null
    return { video, image }
  }, [media])

  const prefersReducedMotion = () => process.browser && document.documentElement.classList.contains("prefers-reduced-motion")

  useEffect(() => {
    if (!ready) {
      if (_timeout) clearTimeout(_timeout)

      _timeout = setTimeout(() => {
        setReady(true)
      }, 100)
    }
    if (ready) {
      requestAnimationFrame(() => {
        if (!prefersReducedMotion() && !rvideo.current.node.playing) rvideo.current.node.play()
      })
    }
  }, [ready])

  return (
    <Root className={themeClass}>
      {ready && (video || image) && (
        <MediaContainer onClick={onMediaClick}>
          {video ? (
            <Video ref={rvideo} {...video} noButton autoPause={false} sizes='100vw' preload='auto' />
          ) : (
            <Image {...image} sizes='100vw' loading='eager' />
          )}
        </MediaContainer>
      )}

      <TextBlock
        heading={heading}
        cta={cta}
        // opacity={reducedMotion ? (installationVisible ? 0 : 1) : isRollerFocusWithin ? 0 : textOpacity}
        // isinteractive={!installationVisible}
        use_os_logo={use_os_logo}
        animated_logo={animated_logo}
      />
      {/* <ScrollInvit /> */}
    </Root>
  )
}
